/**
 * Shared helpers for workshop city flow (PDP wizard + state collection).
 */
(function (global) {
  var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  var DOW = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

  function slotBookable(slot) {
    if (!slot) return false;
    var st = String(slot.status || '').toLowerCase();
    if (st === 'sold_out' || st === 'cancelled') return false;
    var cap = slot.capacity_remaining;
    if (cap != null && cap !== '' && Number(cap) <= 0) return false;
    return true;
  }

  function slotDateKey(slot) {
    if (!slot || !slot.date_key) {
      if (slot && slot.schema_start && String(slot.schema_start).length >= 10) {
        return String(slot.schema_start).slice(0, 10);
      }
      return '';
    }
    return String(slot.date_key).slice(0, 10);
  }

  function formatMoney(cents) {
    if (global.Shopify && typeof global.Shopify.formatMoney === 'function') {
      return global.Shopify.formatMoney(cents);
    }
    return '$' + (Number(cents) / 100).toFixed(2);
  }

  function buildDaysMap(slots, bookableOnly) {
    var map = {};
    (slots || []).forEach(function (s) {
      var dk = slotDateKey(s);
      if (!dk) return;
      if (!map[dk]) map[dk] = { bookable: false, any: true };
      if (!bookableOnly || slotBookable(s)) {
        if (slotBookable(s)) map[dk].bookable = true;
        map[dk].any = true;
      }
    });
    return map;
  }

  function renderCalendarGrid(opts) {
    var root = opts.root;
    var viewMonth = opts.viewMonth;
    var selectedDate = opts.selectedDate || '';
    var daysWithEvents = opts.daysWithEvents || {};
    var sel = opts.selectors || {};
    var dayAttr = sel.dayAttr || 'data-wcf-cal-day';
    var monthLabel = root.querySelector(sel.monthLabel || '[data-wcf-cal-month-label]');
    var dowEl = root.querySelector(sel.dow || '[data-wcf-cal-dow]');
    var grid = root.querySelector(sel.grid || '[data-wcf-cal-grid]');
    if (!grid) return;

    var y = viewMonth.getFullYear();
    var m = viewMonth.getMonth();
    if (monthLabel) monthLabel.textContent = MONTHS[m] + ' ' + y;
    if (dowEl) {
      dowEl.innerHTML = DOW.map(function (d) {
        return '<span class="wcf-cal-dow">' + d + '</span>';
      }).join('');
    }

    var first = new Date(y, m, 1);
    var startPad = first.getDay();
    var daysInMonth = new Date(y, m + 1, 0).getDate();
    var html = '';
    var i;
    for (i = 0; i < startPad; i++) html += '<span class="wcf-cal-day wcf-cal-day--empty"></span>';
    for (var d = 1; d <= daysInMonth; d++) {
      var key = y + '-' + String(m + 1).padStart(2, '0') + '-' + String(d).padStart(2, '0');
      var info = daysWithEvents[key];
      var cls = 'wcf-cal-day';
      if (!info) cls += ' wcf-cal-day--muted';
      else {
        cls += ' wcf-cal-day--has-event';
        if (!info.bookable) cls += ' wcf-cal-day--soldout-only';
      }
      if (selectedDate === key) cls += ' wcf-cal-day--selected';
      var disabled = !info ? ' disabled' : '';
      html +=
        '<span class="wcf-cal-day-wrap"><button type="button" class="' +
        cls +
        '" ' +
        dayAttr +
        '="' +
        key +
        '"' +
        disabled +
        '>' +
        d +
        '</button></span>';
    }
    grid.innerHTML = html;
  }

  function renderPickableCalendarGrid(opts) {
    var root = opts.root;
    var viewMonth = opts.viewMonth;
    var selectedDate = opts.selectedDate || '';
    var sel = opts.selectors || {};
    var dayAttr = sel.dayAttr || 'data-wcf-wl-cal-day';
    var monthLabel = root.querySelector(sel.monthLabel || '[data-wcf-wl-cal-month-label]');
    var dowEl = root.querySelector(sel.dow || '[data-wcf-wl-cal-dow]');
    var grid = root.querySelector(sel.grid || '[data-wcf-wl-cal-grid]');
    if (!grid) return;
    var y = viewMonth.getFullYear();
    var m = viewMonth.getMonth();
    if (monthLabel) monthLabel.textContent = MONTHS[m] + ' ' + y;
    if (dowEl) {
      dowEl.innerHTML = DOW.map(function (d) {
        return '<span class="wcf-cal-dow">' + d + '</span>';
      }).join('');
    }
    var first = new Date(y, m, 1);
    var startPad = first.getDay();
    var daysInMonth = new Date(y, m + 1, 0).getDate();
    var html = '';
    var i;
    for (i = 0; i < startPad; i++) html += '<span class="wcf-cal-day wcf-cal-day--empty"></span>';
    for (var d = 1; d <= daysInMonth; d++) {
      var key = y + '-' + String(m + 1).padStart(2, '0') + '-' + String(d).padStart(2, '0');
      var cls = 'wcf-cal-day wcf-cal-day--pickable';
      if (selectedDate === key) cls += ' wcf-cal-day--selected';
      html +=
        '<span class="wcf-cal-day-wrap"><button type="button" class="' +
        cls +
        '" ' +
        dayAttr +
        '="' +
        key +
        '">' +
        d +
        '</button></span>';
    }
    grid.innerHTML = html;
  }

  function getCartSections() {
    try {
      if (global.Alpine && global.Alpine.store && global.Alpine.store('xCartHelper')) {
        return global.Alpine.store('xCartHelper').getSectionsToRender().map(function (s) {
          return s.id;
        });
      }
    } catch (_) {}
    return [];
  }

  function dispatchCartUi(body) {
    try {
      if (body && body.sections && global.Alpine && global.Alpine.store && global.Alpine.store('xCartHelper')) {
        global.Alpine.store('xCartHelper').reRenderSections(body.sections);
      }
    } catch (_) {}
    try {
      if (global.Alpine && global.Alpine.store && global.Alpine.store('xCartHelper')) {
        var bubble = document.querySelector('#cart-icon-bubble span');
        global.Alpine.store('xCartHelper').currentItemCount = parseInt((bubble && bubble.innerHTML) || '0', 10);
      }
    } catch (_) {}
    document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
    document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: body } }));
    document.dispatchEvent(new CustomEvent('cart:open'));
    try {
      if (global.Alpine && global.Alpine.store && global.Alpine.store('xMiniCart')) {
        if (!global.Alpine.store('xCartNoti') || !global.Alpine.store('xCartNoti').enable) {
          global.Alpine.store('xMiniCart').openCart();
        }
      }
    } catch (_) {}
  }

  function parseUrlParams() {
    try {
      var p = new URLSearchParams(global.location.search);
      return {
        city: (p.get('city') || '').trim().toLowerCase(),
        date: (p.get('date') || '').trim().slice(0, 10),
        step: (p.get('step') || '').trim().toLowerCase(),
      };
    } catch (_) {
      return { city: '', date: '', step: '' };
    }
  }

  function isWeekendDateKey(dateKey) {
    if (!dateKey) return false;
    var d = new Date(dateKey + 'T12:00:00');
    if (isNaN(d.getTime())) return false;
    var dow = d.getDay();
    return dow === 0 || dow === 6;
  }

  function isWithinNextDays(dateKey, days) {
    if (!dateKey) return false;
    var d = new Date(dateKey + 'T12:00:00');
    if (isNaN(d.getTime())) return false;
    var now = new Date();
    now.setHours(0, 0, 0, 0);
    var end = new Date(now);
    end.setDate(end.getDate() + days);
    return d >= now && d <= end;
  }

  function filterSlots(slots, filters) {
    filters = filters || {};
    return (slots || []).filter(function (s) {
      var dk = slotDateKey(s);
      if (filters.availableOnly && !slotBookable(s)) return false;
      if (filters.thisWeekend && !isWeekendDateKey(dk)) return false;
      if (filters.next7Days && !isWithinNextDays(dk, 7)) return false;
      return true;
    });
  }

  function mergeCityMeta(city, metaByHandle) {
    if (!city || !metaByHandle) return city;
    var m = metaByHandle[city.product_handle];
    if (!m) return city;
    if (!city.featured_image_url && m.featured_image_url) city.featured_image_url = m.featured_image_url;
    if (!city.product_url && m.product_url) city.product_url = m.product_url;
    if (!city.city_name && m.city_name) city.city_name = m.city_name;
    if (!city.venue_name && m.venue_name) city.venue_name = m.venue_name;
    if (m.latitude != null) city.latitude = m.latitude;
    if (m.longitude != null) city.longitude = m.longitude;
    if (!city.title && m.title) city.title = m.title;
    return city;
  }

  function submitWaitlist(url, payload) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
      mode: 'cors',
    }).then(function (res) {
      return res.json().then(function (body) {
        return { ok: res.ok, status: res.status, body: body || {} };
      }).catch(function () {
        return res.text().then(function (txt) {
          return { ok: res.ok, status: res.status, body: { description: txt } };
        });
      });
    }).then(function (r) {
      if (!r.ok) {
        var msg =
          (r.body && (r.body.description || r.body.message || r.body.error)) ||
          'Request failed (' + r.status + ')';
        throw new Error(msg);
      }
      if (r.body && r.body.success === false) {
        throw new Error(r.body.message || r.body.description || 'Could not add to waitlist.');
      }
      return r.body;
    });
  }

  var api = {
    MONTHS: MONTHS,
    DOW: DOW,
    slotBookable: slotBookable,
    slotDateKey: slotDateKey,
    formatMoney: formatMoney,
    buildDaysMap: buildDaysMap,
    renderCalendarGrid: renderCalendarGrid,
    renderPickableCalendarGrid: renderPickableCalendarGrid,
    getCartSections: getCartSections,
    dispatchCartUi: dispatchCartUi,
    parseUrlParams: parseUrlParams,
    filterSlots: filterSlots,
    mergeCityMeta: mergeCityMeta,
    isWeekendDateKey: isWeekendDateKey,
    submitWaitlist: submitWaitlist,
  };
  global.WorkshopBookingWizardCalendar = api;
  // Prefer flow-core as WorkshopCityFlow (live capacity + cart props) when already loaded.
  if (global.WorkshopCityFlow && typeof global.WorkshopCityFlow.appendCartValidationProperties === 'function') {
    Object.keys(api).forEach(function (key) {
      if (global.WorkshopCityFlow[key] == null) global.WorkshopCityFlow[key] = api[key];
    });
  } else {
    global.WorkshopCityFlow = api;
  }
})(typeof window !== 'undefined' ? window : this);
